@if (maneuverForm) {
	<div [formGroup]="maneuverForm">
		<!-- <div class="grid grid-rows-1 gap-4" *ngIf="isManeuverVisible">
    <app-cbta-autocomplete
      [label]="'Select Manevuer'"
      [placeholder]="'Select Manevuer'"
      (focusOut)="saveManeuver($event)"
      [options]="sharedService.dropDownOptionsManeuver"
      [field]="maneuver"
    ></app-cbta-autocomplete>
  </div> -->
		@if (isManeuverVisible) {
			<p>Please Select OB's :</p>
		}
		<div class="ob-selection-section">
			<mat-accordion [multi]="true" class="ob-selection-accordion">
				@for (OB of TS1_OB_LIST; track OB; let i = $index) {
					<mat-expansion-panel
						class="mat-elevation-z0"
						(opened)="panelOpenState = true"
						(closed)="panelOpenState = false"
						[expanded]="hasValue(OB.title)"
					>
						<mat-expansion-panel-header>
							<mat-panel-title>
								<div class="flex w-full grid-cols-2 flex-row items-center gap-4">
									<span class="title whitespace-nowrap"
										><span class="font-bold"> {{ OB.title }}</span>
										<span class="text-lg font-bold">&nbsp;&#183;&nbsp;</span>
										{{ OB.desc }}
									</span>
									<div class="w-full border-b border-b-black"></div>
								</div>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<!-- KNO -->
						@if (OB.title == "KNO") {
							<div class="grid grid-cols-4 gap-4">
								@for (item of OB.item_desc; track item; let j = $index) {
									<ng-container formGroupName="KNO">
										<div>
											<div
												class="h-full cursor-pointer rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
												[class.activeGrid]="KNO.get('KNO' + (j + 1))?.value"
												[class.removed]="isRemoved('KNO', j + 1, KNO)"
												[class.added]="isAdded('KNO', j + 1, KNO)"
												(click)="onCheckBoxClick(KNO.get('KNO' + (j + 1)), 'KNO' + (j + 1))"
											>
												<div class="flex flex-row items-center justify-between">
													<span class="grid-title text-lg font-bold">{{ OB.title + "" + (j + 1) }}</span>
													<div class="checkbox grid-checkBox">
														<mat-checkbox
															[checked]="$safeNavigationMigration(KNO.get('KNO' + (j + 1))?.value)"
															[color]="'primary'"
														>
															@if (!KNO.get("KNO" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg !text-violet">add_box</mat-icon>
															}
															@if (KNO.get("KNO" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg text-violet">indeterminate_check_box</mat-icon>
															}
														</mat-checkbox>
													</div>
												</div>
												<p class="grid-description text-grey-40">{{ item }}</p>
											</div>
										</div>
									</ng-container>
								}
							</div>
						}
						<!-- PRO -->
						@if (OB.title == "PRO") {
							<div class="grid grid-cols-4 gap-4">
								@for (item of OB.item_desc; track item; let j = $index) {
									<ng-container formGroupName="PRO">
										<div>
											<div
												class="h-full cursor-pointer rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
												[class.activeGrid]="PRO.get('PRO' + (j + 1))?.value"
												[class.removed]="isRemoved('PRO', j + 1, PRO)"
												[class.added]="isAdded('PRO', j + 1, PRO)"
												(click)="onCheckBoxClick(PRO.get('PRO' + (j + 1)), 'PRO' + (j + 1))"
											>
												<div class="flex flex-row items-center justify-between">
													<span class="grid-title text-lg font-bold">{{ OB.title + "" + (j + 1) }}</span>
													<div class="checkbox grid-checkBox">
														<mat-checkbox
															[checked]="$safeNavigationMigration(PRO.get('PRO' + (j + 1))?.value)"
															[color]="'primary'"
														>
															@if (!PRO.get("PRO" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg !text-violet">add_box</mat-icon>
															}
															@if (PRO.get("PRO" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg text-violet">indeterminate_check_box</mat-icon>
															}
														</mat-checkbox>
													</div>
												</div>
												<p class="grid-description text-grey-40">{{ item }}</p>
											</div>
										</div>
									</ng-container>
								}
							</div>
						}
						<!-- COM -->
						@if (OB.title == "COM") {
							<div class="grid grid-cols-4 gap-4">
								@for (item of OB.item_desc; track item; let j = $index) {
									<ng-container formGroupName="COM">
										<div>
											<div
												class="h-full cursor-pointer rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
												[class.activeGrid]="COM.get('COM' + (j + 1))?.value"
												[class.removed]="isRemoved('COM', j + 1, COM)"
												[class.added]="isAdded('COM', j + 1, COM)"
												(click)="onCheckBoxClick(COM.get('COM' + (j + 1)), 'COM' + (j + 1))"
											>
												<div class="flex flex-row items-center justify-between">
													<span class="grid-title text-lg font-bold">{{ OB.title + "" + (j + 1) }}</span>
													<div class="checkbox grid-checkBox">
														<mat-checkbox
															[checked]="$safeNavigationMigration(COM.get('COM' + (j + 1))?.value)"
															[color]="'primary'"
														>
															@if (!COM.get("COM" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg !text-violet">add_box</mat-icon>
															}
															@if (COM.get("COM" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg text-violet">indeterminate_check_box</mat-icon>
															}
														</mat-checkbox>
													</div>
												</div>
												<p class="grid-description text-grey-40">{{ item }}</p>
											</div>
										</div>
									</ng-container>
								}
							</div>
						}
						<!-- FPA -->
						@if (OB.title == "FPA") {
							<div class="grid grid-cols-4 gap-4">
								@for (item of OB.item_desc; track item; let j = $index) {
									<ng-container formGroupName="FPA">
										<div>
											<div
												class="h-full cursor-pointer rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
												[class.activeGrid]="FPA.get('FPA' + (j + 1))?.value"
												[class.removed]="isRemoved('FPA', j + 1, FPA)"
												[class.added]="isAdded('FPA', j + 1, FPA)"
												(click)="onCheckBoxClick(FPA.get('FPA' + (j + 1)), 'FPA' + (j + 1))"
											>
												<div class="flex flex-row items-center justify-between">
													<span class="grid-title text-lg font-bold">{{ OB.title + "" + (j + 1) }}</span>
													<div class="checkbox grid-checkBox">
														<mat-checkbox
															[checked]="$safeNavigationMigration(FPA.get('FPA' + (j + 1))?.value)"
															[color]="'primary'"
														>
															@if (!FPA.get("FPA" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg !text-violet">add_box</mat-icon>
															}
															@if (FPA.get("FPA" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg text-violet">indeterminate_check_box</mat-icon>
															}
														</mat-checkbox>
													</div>
												</div>
												<p class="grid-description text-grey-40">{{ item }}</p>
											</div>
										</div>
									</ng-container>
								}
							</div>
						}
						<!-- OB 4.5 -->
						@if (OB.title == "FPM") {
							<div class="grid grid-cols-4 gap-4">
								@for (item of OB.item_desc; track item; let j = $index) {
									<ng-container formGroupName="FPM">
										<div>
											<div
												class="h-full cursor-pointer rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
												[class.activeGrid]="FPM.get('FPM' + (j + 1))?.value"
												[class.removed]="isRemoved('FPM', j + 1, FPM)"
												[class.added]="isAdded('FPM', j + 1, FPM)"
												(click)="onCheckBoxClick(FPM.get('FPM' + (j + 1)), 'FPM' + (j + 1))"
											>
												<div class="flex flex-row items-center justify-between">
													<span class="grid-title text-lg font-bold">{{ OB.title + "" + (j + 1) }}</span>
													<div class="checkbox grid-checkBox">
														<mat-checkbox
															[checked]="$safeNavigationMigration(FPM.get('FPM' + (j + 1))?.value)"
															[color]="'primary'"
														>
															@if (!FPM.get("FPM" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg !text-violet">add_box</mat-icon>
															}
															@if (FPM.get("FPM" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg text-violet">indeterminate_check_box</mat-icon>
															}
														</mat-checkbox>
													</div>
												</div>
												<p class="grid-description text-grey-40">{{ item }}</p>
											</div>
										</div>
									</ng-container>
								}
							</div>
						}
						<!-- LTW -->
						@if (OB.title == "LTW") {
							<div class="grid grid-cols-4 gap-4">
								@for (item of OB.item_desc; track item; let j = $index) {
									<ng-container formGroupName="LTW">
										<div>
											<div
												class="h-full cursor-pointer rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
												[class.activeGrid]="LTW.get('LTW' + (j + 1))?.value"
												[class.removed]="isRemoved('LTW', j + 1, LTW)"
												[class.added]="isAdded('LTW', j + 1, LTW)"
												(click)="onCheckBoxClick(LTW.get('LTW' + (j + 1)), 'LTW' + (j + 1))"
											>
												<div class="flex flex-row items-center justify-between">
													<span class="grid-title text-lg font-bold">{{ OB.title + "" + (j + 1) }}</span>
													<div class="checkbox grid-checkBox">
														<mat-checkbox
															[checked]="$safeNavigationMigration(LTW.get('LTW' + (j + 1))?.value)"
															[color]="'primary'"
														>
															@if (!LTW.get("LTW" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg !text-violet">add_box</mat-icon>
															}
															@if (LTW.get("LTW" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg text-violet">indeterminate_check_box</mat-icon>
															}
														</mat-checkbox>
													</div>
												</div>
												<p class="grid-description text-grey-40">{{ item }}</p>
											</div>
										</div>
									</ng-container>
								}
							</div>
						}
						<!-- PSD -->
						@if (OB.title == "PSD") {
							<div class="grid grid-cols-4 gap-4">
								@for (item of OB.item_desc; track item; let j = $index) {
									<ng-container formGroupName="PSD">
										<div>
											<div
												class="h-full cursor-pointer rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
												[class.activeGrid]="PSD.get('PSD' + (j + 1))?.value"
												[class.removed]="isRemoved('PSD', j + 1, PSD)"
												[class.added]="isAdded('PSD', j + 1, PSD)"
												(click)="onCheckBoxClick(PSD.get('PSD' + (j + 1)), 'PSD' + (j + 1))"
											>
												<div class="flex flex-row items-center justify-between">
													<span class="grid-title text-lg font-bold">{{ OB.title + "" + (j + 1) }}</span>
													<div class="checkbox grid-checkBox">
														<mat-checkbox
															[checked]="$safeNavigationMigration(PSD.get('PSD' + (j + 1))?.value)"
															[color]="'primary'"
														>
															@if (!PSD.get("PSD" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg !text-violet">add_box</mat-icon>
															}
															@if (PSD.get("PSD" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg text-violet">indeterminate_check_box</mat-icon>
															}
														</mat-checkbox>
													</div>
												</div>
												<p class="grid-description text-grey-40">{{ item }}</p>
											</div>
										</div>
									</ng-container>
								}
							</div>
						}
						<!-- SAW -->
						@if (OB.title == "SAW") {
							<div class="grid grid-cols-4 gap-4">
								@for (item of OB.item_desc; track item; let j = $index) {
									<ng-container formGroupName="SAW">
										<div>
											<div
												class="h-full cursor-pointer rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
												[class.activeGrid]="SAW.get('SAW' + (j + 1))?.value"
												[class.removed]="isRemoved('SAW', j + 1, SAW)"
												[class.added]="isAdded('SAW', j + 1, SAW)"
												(click)="onCheckBoxClick(SAW.get('SAW' + (j + 1)), 'SAW' + (j + 1))"
											>
												<div class="flex flex-row items-center justify-between">
													<span class="grid-title text-lg font-bold">{{ OB.title + "" + (j + 1) }}</span>
													<div class="checkbox grid-checkBox">
														<mat-checkbox
															[checked]="$safeNavigationMigration(SAW.get('SAW' + (j + 1))?.value)"
															[color]="'primary'"
														>
															@if (!SAW.get("SAW" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg !text-violet">add_box</mat-icon>
															}
															@if (SAW.get("SAW" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg text-violet">indeterminate_check_box</mat-icon>
															}
														</mat-checkbox>
													</div>
												</div>
												<p class="grid-description text-grey-40">{{ item }}</p>
											</div>
										</div>
									</ng-container>
								}
							</div>
						}
						<!-- WLM -->
						@if (OB.title == "WLM") {
							<div class="grid grid-cols-4 gap-4">
								@for (item of OB.item_desc; track item; let j = $index) {
									<ng-container formGroupName="WLM">
										<div>
											<div
												class="h-full cursor-pointer rounded bg-white p-3 drop-shadow-md lg:min-h-[150px]"
												[class.activeGrid]="WLM.get('WLM' + (j + 1))?.value"
												[class.removed]="isRemoved('WLM', j + 1, WLM)"
												[class.added]="isAdded('WLM', j + 1, WLM)"
												(click)="onCheckBoxClick(WLM.get('WLM' + (j + 1)), 'WLM' + (j + 1))"
											>
												<div class="flex flex-row items-center justify-between">
													<span class="grid-title text-lg font-bold">{{ OB.title + "" + (j + 1) }}</span>
													<div class="checkbox grid-checkBox">
														<mat-checkbox
															[checked]="$safeNavigationMigration(WLM.get('WLM' + (j + 1))?.value)"
															[color]="'primary'"
														>
															@if (!WLM.get("WLM" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg !text-violet">add_box</mat-icon>
															}
															@if (WLM.get("WLM" + (j + 1))?.value) {
																<mat-icon class="grid-icon text-lg text-violet">indeterminate_check_box</mat-icon>
															}
														</mat-checkbox>
													</div>
												</div>
												<p class="grid-description text-grey-40">{{ item }}</p>
											</div>
										</div>
									</ng-container>
								}
							</div>
						}
					</mat-expansion-panel>
				}
			</mat-accordion>
			@if (isSafetyOutcomeVisible) {
				<div class="my-8">
					<app-cbta-checkbox-rating
						name="safetyOutcome"
						label="TEM Safety Outcome"
						(ratingChange)="onRatingChange($event)"
						[rating]="5"
						[currentValue]="$safeNavigationMigration(safetyOutcome?.value)"
					>
					</app-cbta-checkbox-rating>
					<!-- <p>TEM Safety Outcome</p>
                                            <app-cbta-slider class="w-full" [steps]="5" [currentSliderValue]="safetyOutcome?.value ?? 0" (sliderChange)="onSafetyOutcomeSliderChange($event)"></app-cbta-slider> -->
					<input type="hidden" class="hidden" formControlName="safetyOutcome" [value]="safetyOutcome?.value ?? -2" />
				</div>
			}
			@if (isSafetyOutcomeVisible) {
				<div class="m-4 flex flex-row justify-between">
					<div class="grid grid-cols-3 gap-4">
						<button mat-stroked-button class="border !border-black !text-black" (click)="reaptConfirmModal()">
							Repeat
						</button>
					</div>
				</div>
			}
		</div>
	</div>
}
